/* Bee Store — Predictive Search: ao limpar, repõe sugestões (estado inicial)
   FIX Viena/Dawn: repõe APÓS o tema limpar/fechar (restauro com atraso + repetição)
*/
document.addEventListener("DOMContentLoaded", () => {
  const ps =
    document.querySelector("predictive-search") ||
    document.querySelector(".predictive-search");
  if (!ps) return;

  const input = ps.querySelector('input[type="search"]');
  if (!input) return;

  const getWrapper = () =>
    ps.querySelector("#predictive-search-results-groups-wrapper") ||
    ps.querySelector("#predictive-search-results");

  let initialHTML = "";
  let lastValue = (input.value || "").trim();
  let restoring = false;

  const captureInitial = () => {
    if (initialHTML) return;

    const wrapper = getWrapper();
    if (!wrapper) return;

    const val = (input.value || "").trim();
    const html = (wrapper.innerHTML || "").trim();

    // Guardar o estado inicial (com input vazio e com conteúdo)
    if (val === "" && html.length > 0) {
      initialHTML = wrapper.innerHTML;
    }
  };

  const forceOpenResults = () => {
    // Alguns temas têm métodos open/close no custom element
    if (typeof ps.open === "function") {
      try { ps.open(); } catch (e) {}
    }

    ps.classList.remove("predictive-search--no-results");

    const results = ps.querySelector("#predictive-search-results");
    if (results) results.removeAttribute("hidden");

    const groups = ps.querySelector("#predictive-search-results-groups-wrapper");
    if (groups) groups.removeAttribute("hidden");
  };

  const restoreInitial = () => {
    if (restoring) return;
    if (!initialHTML) return;

    const val = (input.value || "").trim();
    if (val !== "") return;

    const wrapper = getWrapper();
    if (!wrapper) return;

    restoring = true;

    wrapper.innerHTML = initialHTML;
    wrapper.removeAttribute("hidden");
    forceOpenResults();

    restoring = false;
  };

  const scheduleRestore = () => {
    // IMPORTANTÍSSIMO: o tema limpa depois do input event — por isso restauramos depois
    setTimeout(restoreInitial, 120);
    setTimeout(restoreInitial, 320); // 2ª passagem para “ganhar” ao JS do tema
  };

  // Ao abrir/focar a pesquisa: dá tempo ao tema para injectar os populares/sugestões
  input.addEventListener("focus", () => {
    setTimeout(captureInitial, 180);
    setTimeout(captureInitial, 400);
  });

  // Ao escrever/apagar
  input.addEventListener("input", () => {
    const val = (input.value || "").trim();

    // Se passou de "texto" -> "vazio", repõe sugestões
    if (val === "" && lastValue !== "") {
      scheduleRestore();
    }

    lastValue = val;

    // Tenta capturar caso as sugestões só tenham aparecido agora
    setTimeout(captureInitial, 0);
  });

  // Evento "search" (muitos browsers disparam ao clicar no X do input)
  input.addEventListener("search", () => {
    const val = (input.value || "").trim();

    if (val === "" && lastValue !== "") {
      scheduleRestore();
    }

    lastValue = val;
    setTimeout(captureInitial, 0);
  });

  // Reset do form (se existir)
  const form = input.closest("form");
  if (form) {
    form.addEventListener("reset", () => {
      lastValue = "";
      scheduleRestore();
    });
  }

  // Observa alterações: só para capturar o HTML inicial quando ele aparecer
  const mo = new MutationObserver(() => captureInitial());
  mo.observe(ps, { childList: true, subtree: true });

  // Boot
  setTimeout(captureInitial, 250);
});
